/**
 * trainer-comments-dialog.js
 */

import React from 'react';
import { TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Dialog from 'components/dialog';
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';


const useStyles = makeStyles(theme => ({
  textField: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
    }
  }
}));



export default function TrainerCommentsDialog(props) {
  const { 
    answerId,
    children,
    drawerState,
  } = props;
  const classes = useStyles();
  const recordStore = useRecordStore();
  const record = recordStore.useRecord(Types.Record.ANSWER, answerId).ornull;
  const [isOpen, setIsOpen] = React.useState(false);
  const [comments, setComments] = React.useState('');
  const trainerComments = record && record.trainerComments.get() 
    ? record.trainerComments.get().comments 
    : '';


  const newChildren = React.Children.map(children, child => {
    return React.cloneElement(child, {
      'aria-label': 'trainer-comments-dialog',
      'aria-controls': '',
      'aria-haspopup': true,
      onClick: () => setIsOpen(true)
    });
  });


  React.useEffect(() => {
    setComments(trainerComments);
  }, [trainerComments]);


  const saveComments = async () => {
    drawerState.loading.content.set(true);
    await recordStore.setTrainerComments(answerId, comments);
    drawerState.loading.content.set(false);
  }

  
  return (
    <>
      {newChildren}

      <Dialog
        maxWidth='sm'
        fullWidth
        title='Trainer Comments'
        titleIcon='trainer-comments'
        open={isOpen}
        autoFocusOkButton={false}
        onClose={() => {
          setIsOpen(false);
          setComments(comments || '');
        }}
        onOk={() => {
          setIsOpen(false);
          saveComments();
        }}
      >
        <TextField 
          variant='outlined'
          size='small'
          fullWidth
          multiline
          autoFocus
          rows={10}
          placeholder='Enter your trainer comments...'
          value={comments}
          className={classes.textField}
          onChange={e => setComments(e.target.value)}
          inputProps={{ 'data-testid': 'trainer-comments-input' }}
        />
      </Dialog>
    </>
  )
}